import Flickity from 'flickity';
import 'flickity-imagesloaded';

const initShogunSlider = () => {
  const sliders = document.querySelectorAll('.shg-custom-slider');

  if (sliders.length > 0) {
    sliders.forEach(elem => {
      const slider = elem.querySelector('.shg-row');

      new Flickity(slider, {
        freeScroll: false,
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        imagesLoaded: true,
        lazyLoad: true,
        cellAlign: 'left',
        watchCSS: true,
        wrapAround: false,
        groupCells: true,
      });
    });
  }
};

export default initShogunSlider;
